import {
  WithMarginProps,
  withMargin,
} from 'style-utils/withStyledProps/withMarginProps';
import styled from 'styled-components';

export type IconRootProps = {
  iconSize?: string;
  iconHeight?: string;
  className?: string;
  iconSrc?: string;
  inlineIconSrc?: boolean;
  onClick?: () => void;
} & WithMarginProps;

export const IconRoot = styled.div.attrs<IconRootProps>(
  ({ iconSrc, inlineIconSrc }) => ({
    // Use style directly as a performance optimization when you need to render
    // a alot of icons:
    // inlined styles can be overridden only with '!important'.
    style: {
      backgroundImage:
        iconSrc && inlineIconSrc ? `url("${iconSrc}")` : undefined,
    },
  }),
)<IconRootProps>`
  display: inline-flex;
  padding: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  ${({ iconSize = '24px', iconHeight }) => `
    width: ${iconSize};
    height: ${iconHeight || iconSize};
  `};
  ${({ iconSrc, inlineIconSrc }): string => {
    if (iconSrc && !inlineIconSrc) {
      return `background-image: url("${iconSrc}");`;
    }
    return '';
  }};

  ${withMargin};
`;
IconRoot.defaultProps = {
  inlineIconSrc: false,
  'aria-hidden': true,
};
